module.exports = __webpack_public_path__ + "img/foodSafety-devices.6a667ed0.png";